module.exports = __webpack_public_path__ + "img/plexus-11.c7e98bab.png";